// extracted by mini-css-extract-plugin
export default {"versionAndPillsWrapper":"VersionAndPillsWrapper_versionAndPillsWrapper__ujlCC"};